const { Placeholder } = wp.components;
const { Fragment, Component } = wp.element;

import Inspector from './Inspector';

class BlockEdit extends Component {
	
	
	
	render() {
	
		const { attributes, setAttributes } = this.props;
		
		return (
			<Fragment>
			
				<Inspector {...this.props} />
				
				{
				this.props.media == undefined && 
					<Placeholder icon="images-alt2" label="No Images" instructions="Add Images from the Settings Panel" isColumnLayout={true} />
				}
				
				{
				this.props.media != undefined && 
					<div	className={'block_carousel_images'}
							data-id={attributes.clientId}>
							
							{this.props.media.map(image => (
								<figure>
						            <img 	src={image.source_url}
											height={image.media_details.sizes.medium.height}
											width={image.media_details.sizes.medium.width}
									/>
								</figure>
							))}
					</div>
				}
			</Fragment>
	
		);
	}
}


export default BlockEdit;